import React from 'react';
import {MDBBtn, MDBBtnGroup, MDBInput} from "mdb-react-ui-kit";

const NumberKol = (props) => {
    return (
        <MDBBtnGroup  size='sm' aria-label='Basic example'>
            <MDBBtn
                color='dark'
            >Количество:</MDBBtn>
            <MDBBtn
                color="light"
                outline
                onClick={props.decKol}
            >-</MDBBtn>
            <MDBBtn color="light">{props.value}</MDBBtn>
            <MDBBtn color="light" outline
                    onClick={props.incKol}>+</MDBBtn>
        </MDBBtnGroup>
    );
};

export default NumberKol;